module.exports = __webpack_public_path__ + "aec95f44de6e5b42e2e79c0779a97e4d.pdf";